/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/shipyard_3': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 19.664L31.414 16l-3.664-3.664V4.25h-8.086L16 .586 12.336 4.25H4.25v8.086L.586 16l3.664 3.664v8.086h8.086L16 31.414l3.664-3.664h8.086v-8.086zm-.5-14.914v7.086L20.164 4.75h7.086zm-22.5 0h7.086L4.75 11.836V4.75zm0 22.5v-7.086l7.086 7.086H4.75zM3.414 16L16 3.414 28.586 16 16 28.586 3.414 16zm16.75 11.25l7.086-7.086v7.086h-7.086z"/><path pid="1" d="M17.957 11.456L16 15.369l-1.957-3.913z"/><path pid="2" d="M13.391 11.456L16 17.047l2.609-5.591h1.955L16 20.587l-4.565-9.131z"/><path pid="3" d="M10.783 11.456L16 21.893l5.217-10.437h1.304L15.99 24.5 9.478 11.456zM18.609 10.152h1.957v.652h-1.957zM14.043 9.5h3.913v1.305h-3.913zM11.435 10.152h1.957v.652h-1.957z"/><path pid="4" d="M12.087 19.282h-.652v-3.913l.652 1.305zM20.564 19.282h-.651v-2.608l.651-1.305z"/>'
  }
})
